export default __webpack_public_path__ + "static/media/how-it-works--tablet@2x.28b5f6f1.webp";